import {ComplexFormControl, FieldType, FormBuilder, RequiredValidator} from "@ha/formhandler";
import {OWN_API_TOKEN_DEFAULT_DAYS} from "../../helpers/own-api-token.state";

/** The values the "Neues API-Token" form holds. */
export type OwnApiTokenFormData = {
    name: string,
    expiresInDays: number,
    currentPassword: string,
}

const required = new RequiredValidator();

/** At most this many characters for a name (CreateApiTokenCommandHandler::MAX_NAME_LENGTH). */
export const OWN_API_TOKEN_NAME_MAX_LENGTH = 100;

/** Builds the empty "Neues API-Token" form: name, validity (90 days preselected), current password. */
export function createOwnApiTokenForm(): ComplexFormControl<OwnApiTokenFormData, unknown> {
    return FormBuilder.buildForm('own-api-token', [
        {type: FieldType.Primitive, key: `name`, initialValue: ``, validations: [required]},
        {type: FieldType.Primitive, key: `expiresInDays`, initialValue: OWN_API_TOKEN_DEFAULT_DAYS, validations: [required]},
        {type: FieldType.Primitive, key: `currentPassword`, initialValue: ``, validations: [required]},
    ]);
}

/** The length of the trimmed name in characters (code points, as the server's mb_strlen counts — not UTF-16 units). */
function nameLength(form: ComplexFormControl<OwnApiTokenFormData, unknown>): number {
    return [...(form.getValue()?.name ?? '').trim()].length;
}

/** Whether a typed name is longer than the server accepts (shown as a hint under the form). */
export function ownApiTokenNameTooLong(form: ComplexFormControl<OwnApiTokenFormData, unknown>): boolean {
    return nameLength(form) > OWN_API_TOKEN_NAME_MAX_LENGTH;
}

/** Whether the form may be sent: every field filled and the trimmed name within the length limit. */
export function isOwnApiTokenFormSavable(form: ComplexFormControl<OwnApiTokenFormData, unknown>): boolean {
    const length = nameLength(form);

    return form.getValidationErrors().length === 0 && length > 0 && length <= OWN_API_TOKEN_NAME_MAX_LENGTH;
}
